import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { connect } from "react-redux";
import { Button } from "reactstrap";
import api from "../../utils/Api";
import moment from "moment";
import { Link } from "react-router-dom";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import style from "./InventoryList.module.css";
import { fetchInventoryList } from "../../redux";
import ttmLodader from "../../assets/images/ttm-loader.gif";
import ProductSlider from "../ProductSlider/ProductSlider";
import { checkIfPermitted, Permissions } from "../../services/RolePermissionService";
import ttmLoader from "../../assets/images/ttm-loader.gif";
import history from "../../utils/history";

function dateFormatter(cell) {
  if (!cell) {
    return "";
  }
  return `${
    moment(cell).format("YYYY-MM-DD")
      ? moment(cell).format("YYYY-MM-DD")
      : moment(cell).format("YYYY-MM-DD")
  }`;
}

export class InventoryList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchKey: "",
      page: 1,
      sortName: undefined,
      sortOrder: undefined,
      sortBy: "",
      isEditMode: "",
      isDataFetched: false,
      isModalOpen: false,
      isModalOpenProduct: false,
      isProductModalLoading: false,
      successMessage: "",
      errorMessage: "",
      // Product details
      inventory_id: "",
      deletion_reason_id: "",
      deletion_reason: "",
      product_name: "",
      category_name: "",
      Supplier: "",
      Manufacturer: "",
      unique_code: "",
      nappi_code: "",
      manufacture_date: "",
      loading_date: "",
      salesby_date: "",
      expiry_date: "",
      quantity: "",
      filterOption: "all",
      inventoryList: [],
      outofstock: "",
      stockcheck: "",
    };
  }
  componentDidMount = async() =>{
    document.title = 'Products - TechToMedix';
    if(this.props.location && 
      this.props.location.params && 
      (this.props.location.params.outofstock || this.props.location.params.stockcheck) ){
        let params = this.props.location.params;
        this.setState({
          outofstock: params.outofstock?params.outofstock:"",
          stockcheck: params.stockcheck?params.stockcheck:""
        },async()=>{
            await this.props.fetchInventoryList(
              this.state.searchKey,
              this.state.sortBy,
              this.state.page,
              this.props.location.params.outofstock,
              this.props.location.params.stockcheck
            );
            if(this.props.inventoryListData && 
              this.props.inventoryListData.inventoryList && 
              this.props.inventoryListData.inventoryList.inventory){
          
                this.setState({
                  inventoryList: this.props.inventoryListData.inventoryList.inventory
                })
          
            setTimeout(() => {
              if (this.props.inventoryListData.inventoryList.total === 0) {
                this.setState({
                  isDataFetched: true,
                });
              } else {
                this.setState({
                  isDataFetched: false,
                });
                setTimeout(() => {
                  this.setState({
                    isDataFetched: true,
                  });
                }, 500);
              }
            }, 1000);
          }
        })
      }else{
        await this.props.fetchInventoryList(
              this.state.searchKey,
              this.state.sortBy,
              this.state.page
            );   
            if(this.props.inventoryListData && 
              this.props.inventoryListData.inventoryList && 
              this.props.inventoryListData.inventoryList.inventory){
          
                this.setState({
                  inventoryList: this.props.inventoryListData.inventoryList.inventory
                })
          
            setTimeout(() => {
              if (this.props.inventoryListData.inventoryList.total === 0) {
                this.setState({
                  isDataFetched: true,
                });
              } else {
                this.setState({
                  isDataFetched: false,
                });
                setTimeout(() => {
                  this.setState({
                    isDataFetched: true,
                  });
                }, 500);
              }
            }, 1000);         
  }
}
}

  calInventoryListAPI = async(queryString) => {
    this.setState({
      inventoryList: []
    })
    let queryValue =  queryString ? queryString : "&search_key=" + this.state.searchKey;
    await this.props.fetchInventoryList(
      queryValue,
      this.state.sortBy,
      this.state.page,
      this.state.outofstock,
      this.state.stockcheck
    );

    if(!this.props.inventoryListData.loading){
      this.setState({
        inventoryList: this.props.inventoryListData.inventoryList.inventory
      })
      setTimeout(() => {
        this.setState({
          isDataFetched: true,
        });
    }, 1000);
    }
  }

  selectChange = (event) => {
    let filterVal = event.target.value;
    this.setState({
      filterOption: filterVal,
      page: 1,
      isDataFetched: false
    },()=>{
      let queryString;
    switch (this.state.filterOption) {
      case "sub_category_name":
        queryString = "&sub_category_name=" + this.state.searchKey;
        break;
      default:
        queryString = "&search_key=" + this.state.searchKey;
    }
    this.calInventoryListAPI(queryString);
    });
  };

  onSearchChange = (event) => {
    let searchText = event.target.value;
    this.setState({ searchKey: searchText, page: 1, isDataFetched: false },()=>{

      let queryString;
      switch (this.state.filterOption) {
        case "sub_category_name":
          queryString = "&sub_category_name=" + searchText;
          break;
        default:
          queryString = "&search_key=" + searchText;
      }
  
      this.calInventoryListAPI(queryString);
    });
  };

  onSortChange = (sortName, sortOrder) => {
    let sortBy;
    if (sortOrder == "desc") {
      sortBy = "-" + sortName;
    } else {
      sortBy = sortName;
    }
    this.setState({
      sortName,
      sortOrder,
      sortBy,
      page: 1,
      isDataFetched: false,
    },()=>{
      this.calInventoryListAPI();
    });
  };

  // onSearchChange = (searchText) => {
  //   this.setState({ searchKey: searchText, page: 1, isDataFetched: true });
  //   this.props.fetchInventoryList(searchText, this.state.sortBy, 1);
  // };

  onPageChange = (page, sizePerPage) => {
    this.setState({ page, isDataFetched: false },()=>{
      let queryString;
    switch (this.state.filterOption) {
      case "sub_category_name":
        queryString = "&sub_category_name=" + this.state.searchKey;
        break;
      default:
        queryString = "&search_key=" + this.state.searchKey;
    }

    this.calInventoryListAPI(queryString);
    });
  };

  toggle = (val) => {
    this.setState((prevState) => ({
      inventory_id: val.inventory_id,
      isModalOpen: !prevState.isModalOpen,
    }));
  };

  toggleProductView = (val) => {
    // console.log("++++++++", val);
    this.setState((prevState) => ({
      isModalOpenProduct: !prevState.isModalOpenProduct,
      isProductModalLoading: true,
      product_name: val.product_name,
      category_name: val.category_name,
      inventory_id: val.inventory_id,
      Supplier: val.Supplier,
      Manufacturer: val.Manufacturer,
      unique_code: val.unique_code,
      nappi_code: val.nappi_code,
      manufacture_date: moment(val.manufacture_date).format("YYYY-MM-DD"),
      loading_date: moment(val.loading_date).format("YYYY-MM-DD"),
      salesby_date: moment(val.salesby_date).format("YYYY-MM-DD"),
      expiry_date: moment(val.expiry_date).format("YYYY-MM-DD"),
      quantity: val.quantity,
    }));

    setTimeout(() => {
        this.setState({
          isProductModalLoading: false,
        });
    }, 1000);

  };

  // Adding actions edit and delete icons
  actionsFormatter = (cell, row) => {
   // console.log("++++++++++", row);
    return (
      <div>
        <Link title="View Product">
          <i
            class={`fa fa-eye ${style.productView} relatedpartylist-edit-icon`}
            onClick={() => this.toggleProductView(row)}
          ></i>
        </Link>
        {checkIfPermitted(Permissions.LOAD_INVENTORY) && (
          <Link title="Edit Product"
            to={{ pathname: `/app/addsupply/${row.inventory_id}`, state: row }}
          >
            <i class="fa fa-pencil-square-o mr-3 relatedpartylist-edit-icon"></i>
          </Link>
        )}
        <Link title="Delete Product"
          class="action-icons relatedpartylist-add-icon"
          onClick={() => this.toggle(row)}
        >
          <i class="fa fa-trash"></i>
        </Link>
      </div>
    );
  }

  handleSelectChange = (e) => {
    let index = e.nativeEvent.target.selectedIndex;
    let label = e.nativeEvent.target[index].text;
    let value = e.target.value;
    this.setState({ deletion_reason_id: value, deletion_reason: label });
  };

  // Delete API calling
  onDeleteProduct = async() => {
    if(this.state.deletion_reason_id !== ""){
    try {
      const response = await api.delete("inventory/", {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
        },
        data: {
          inventory_id: this.state.inventory_id,
          deletion_reason_id: this.state.deletion_reason_id,
          deletion_reason: this.state.deletion_reason,
        },
      });
      if (response.status === 200) {
        this.setState({
          successMessage: "Product deletion sent for approval!",
        });
        setTimeout(() => {
          this.setState((prevState) => ({
            successMessage: "",
            isModalOpen: !prevState.isModalOpen,
          }));
            this.calInventoryListAPI();
        }, 3000);
      }
    } catch (error) {
      this.setState({
        errorMessage: "Internal server error occurred",
      });
      setTimeout(() => {
        this.setState((prevState) => ({
          errorMessage: "",
        }));
      }, 3000);
    }
  }else{
    this.setState({
      errorMessage: "Deletion reason is required!",
    });
    setTimeout(() => {
      this.setState((prevState) => ({
        errorMessage: "",
      }));
    }, 3000);
  }
  };

  setLoader() {
    if (this.state.isDataFetched) {
      return <p>There is no data to display</p>;
    } else {
      return (
        <div>
          <img src={ttmLodader} alt="loader" className="loader-image" />
        </div>
      );
    }
  }

  goBack = () => {
    history.goBack();
  }

  render =()=> {
    const inventoryList = this.props.inventoryListData.inventoryList;

    // getting dropdown list options from redux persist
    const dropdownData = this.props.dropdownListData.dropdownList;
    // Getting deleted reasons
    const deleteReasons =
      dropdownData.lk_product_deletion_reason &&
      dropdownData.lk_product_deletion_reason.map((element, index) => (
        <option key={index} value={element.deletion_reason_id}>
          {element.deletion_reason}
        </option>
      ));
    return (
      <div
        className={`inventory-list-wrapper ${style.inventoryListMainWrapper}`}
      >
        {this.props.location.state && 
      this.props.location.state.fromNotifications === 1 &&  ( 
        <div className="mb-2">
            <span className="goBackBtn" onClick={this.goBack}>
              <i class="fa fa-arrow-left" aria-hidden="true"></i>{" "}
              Go Back to Notifications</span>
          </div>)}
        <div className="row">
          <div className="col-lg-6">
            <h3>Products List</h3>
          </div>
          <div className="col-lg-6 d-flex flex-wrap justify-content-center justify-content-sm-end">
            <div className="form-group">
              <input
                type="text"
                className={`form-control ${style.inputSearch}`}
                id="search"
                placeholder="Search here"
                onChange={this.onSearchChange}
              />
            </div>
            <div>
              <label class="form-control border-0">in</label>
            </div>
            <div className="form-group">
              <select
                className="form-control"
                id="searchIn"
                onChange={this.selectChange}
              >
                <option value="all">All</option>
                <option value="sub_category_name">Sub Category</option>
              </select>
            </div>
          </div>
          {/* <div className={`col ${style.addRoleBtnWrapper}`}>
            <Button color="primary" className={style.addBtn}>
              <i className="fa fa-plus mr-2"></i>ADD ROOM
            </Button>
          </div> */}
          
        </div>

        <div className="row">
        <div className="col-lg-12 intro-text">
            <p className="mb-4">
              This is the list of all the products from the inventory. View
              action will show all the details about the product. Edit and
              delete actions are also provided.
            </p>
          </div>
        </div>
        <BootstrapTable
          bordered={false}
          remote={true}
          data={this.state.inventoryList}
          version="4"
          // search
          pagination
          fetchInfo={{
            dataTotalSize: this.props.inventoryListData.inventoryList.total,
          }}
          options={{
            sortName: this.state.sortName,
            sortOrder: this.state.sortOrder,
            onSortChange: this.onSortChange,
            onSearchChange: this.onSearchChange,
            sizePerPage: 10,
            page: this.state.page,
            onPageChange: this.onPageChange,
            noDataText: this.setLoader()
          }}
        >
          <TableHeaderColumn dataField="product_name" isKey dataSort={true}>
            Name
          </TableHeaderColumn>
          <TableHeaderColumn dataField="unique_code" dataSort={true}>
            Unique Code
          </TableHeaderColumn>
          <TableHeaderColumn dataField="sub_category_name" dataSort={true}>
            Sub Category
          </TableHeaderColumn>
          <TableHeaderColumn dataField="quantity" dataSort={true}>
            Quantity
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="loading_date"
            dataSort={true}
            dataFormat={dateFormatter}
          >
            Loading Date
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="actions"
            dataFormat={this.actionsFormatter.bind(this)}
            width="20%"
          >
            Actions
          </TableHeaderColumn>
        </BootstrapTable>
        {/* Open a modal for delete procedure */}
        <Modal
          isOpen={this.state.isModalOpen}
          toggle={this.toggle}
          className={style.deleteReason}
          centered
        >
          <ModalHeader toggle={this.toggle} className={style.deleteModalHeader}>
            Delete Product
          </ModalHeader>
          <ModalBody>
            <div className={style.deleteReasonHeadingWrapper}>
              <p>Please confirm whether you want to delete the product.</p>
            </div>
            <div className={style.deleteReasonFormWrapper}>
              <form onSubmit={this.onSubmit}>
              <div className="form-group">
                    <select
                      className={`form-control ${style.customFormControl}`}
                      id="deletion_reason_id"
                      value={this.state.deletion_reason_id}
                      onChange={this.handleSelectChange}
                      name="deletion_reason_id"
                    >
                      <option value="">Select Reason</option>
                      {deleteReasons}
                    </select>
                  </div>
                <div className={style.error}>{this.state.errorField}</div>
                <div className="row">
                  <div className={`col-md-12 ${style.deleteBtnWrapper}`}>
                    <button
                      type="button"
                      className="ttm-primary-btn"
                      onClick={this.onDeleteProduct}
                    >
                      Delete
                    </button>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    {this.state.successMessage && (
                      <p className={style.successMessage}>
                        {this.state.successMessage}
                      </p>
                    )}
                    {this.state.errorMessage && (
                      <p className={style.errorMessage}>
                        {this.state.errorMessage}
                      </p>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </ModalBody>
        </Modal>

        {/* Open a product view */}
        <Modal
          isOpen={this.state.isModalOpenProduct}
          toggle={this.toggleProductView}
          className="viewProductDetailsModal"
          centered
        >
          {this.state.isProductModalLoading ? (
          <div className={style.loadingWrapper}>
            <img src={ttmLoader} alt="modal-loader" className={style.loading} />
          </div>
        ) : (
          <React.Fragment>
          <ModalHeader
            toggle={this.toggleProductView}
            className={style.deleteModalHeader}
          >
            {this.state.product_name}
          </ModalHeader>
          <ModalBody>
            <div className={style.productviewDetailsWrapper}>
              <div className="row">
                <div className="col-md-6 mb-4 mb-md-0">
                  <ProductSlider inventoryId={this.state.inventory_id} />
                </div>
                <div className="col-md-6">
                  <div className={style.productViewRight}>
                    <p>
                      Category :{" "}
                      <span className={style.nameSpace}>
                        {this.state.category_name}
                      </span>
                    </p>
                    <p>
                      Supplier :{" "}
                      <span className={style.nameSpace}>
                        {this.state.Supplier}
                      </span>
                    </p>
                    <p>
                      Manufacturer :{" "}
                      <span className={style.nameSpace}>
                        {this.state.Manufacturer}
                      </span>
                    </p>
                    <p>
                      Unique Code :{" "}
                      <span className={style.nameSpace}>
                        {this.state.unique_code}
                      </span>
                    </p>
                    <p>
                      Nappi Code :{" "}
                      <span className={style.nameSpace}>
                        {this.state.nappi_code}
                      </span>
                    </p>
                    <p>
                      Manufacturing Date :{" "}
                      <span className={style.nameSpace}>
                        {this.state.manufacture_date}
                      </span>
                    </p>
                    <p>
                      Loading Date :{" "}
                      <span className={style.nameSpace}>
                        {this.state.loading_date}
                      </span>
                    </p>
                    <p>
                      Sale by Date :{" "}
                      <span className={style.nameSpace}>
                        {this.state.salesby_date}
                      </span>
                    </p>
                    <p>
                      Expiry Date :
                      <span className={style.nameSpace}>
                        {this.state.expiry_date}
                      </span>
                    </p>
                    <p>
                      Quantity :
                      <span className={style.nameSpace}>
                        {this.state.quantity}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
        </React.Fragment>
        )}
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    inventoryListData: state.inventoryList,
    dropdownListData: state.dropdownList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchInventoryList: (searchKey, sortBy, page, outofstock,stockcheck) =>
      dispatch(fetchInventoryList(searchKey, sortBy, page, outofstock, stockcheck)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InventoryList);
